import { useState, useEffect } from 'react';
import ImageUpload from '../ImageUpload';

export default function PromoSection() {
  const [data, setData] = useState({
    title_line1: '',
    subtitle_line1: '',
    subtitle_line2: '',
    subtitle_line3: '',
    subtitle_line4: '',
    post_image1: '',
    post_image2: '',
    post_image3: '',
    post_url1: '',
    post_url2: '',
    post_url3: '',
    instagram_url: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://mulata.wortik.com/bolacha-mulata/api/promo.php');
      const result = await response.json();
      setData(result);
    } catch (err) {
      setMessage('Erro ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      const response = await fetch('https://mulata.wortik.com/bolacha-mulata/api/promo.php', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      setMessage(result.success ? 'Salvo com sucesso!' : 'Erro ao salvar');
    } catch (err) {
      setMessage('Erro ao salvar dados');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Promoções (Instagram)</h2>

      <div className="space-y-4">
        {/* Title */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Título Principal</h3>
          <input
            type="text"
            value={data.title_line1}
            onChange={(e) => setData({ ...data, title_line1: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="SEGUE-ME!"
          />
        </div>

        {/* Subtitle Lines */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Subtítulo (4 linhas)</h3>
          <div className="space-y-2">
            <input
              type="text"
              value={data.subtitle_line1}
              onChange={(e) => setData({ ...data, subtitle_line1: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 1: PROMETO"
            />
            <input
              type="text"
              value={data.subtitle_line2}
              onChange={(e) => setData({ ...data, subtitle_line2: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 2: NÃO DEIXAR"
            />
            <input
              type="text"
              value={data.subtitle_line3}
              onChange={(e) => setData({ ...data, subtitle_line3: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 3: MIGALHAS"
            />
            <input
              type="text"
              value={data.subtitle_line4}
              onChange={(e) => setData({ ...data, subtitle_line4: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 4: NO TEU FEED."
            />
          </div>
        </div>

        {/* Instagram Posts - Each with Image and URL */}
        <div className="bg-gray-50 p-4 rounded-lg space-y-6">
          <h3 className="font-semibold text-gray-800 mb-3">Publicações do Instagram</h3>
          
          {/* Post 1 */}
          <div className="border-b border-gray-200 pb-4">
            <h4 className="font-medium text-gray-700 mb-3">📸 Publicação 1</h4>
            <ImageUpload
              currentImage={data.post_image1}
              onImageChange={(path) => setData({ ...data, post_image1: path })}
              label="Imagem da Publicação 1"
            />
            <div className="mt-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                URL do Post (Instagram)
              </label>
              <input
                type="url"
                value={data.post_url1 || ''}
                onChange={(e) => setData({ ...data, post_url1: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/DUF3bTgFHz6/"
              />
              <p className="text-xs text-gray-500 mt-1">
                💡 Cole o link direto do post do Instagram
              </p>
            </div>
          </div>

          {/* Post 2 */}
          <div className="border-b border-gray-200 pb-4">
            <h4 className="font-medium text-gray-700 mb-3">📸 Publicação 2</h4>
            <ImageUpload
              currentImage={data.post_image2}
              onImageChange={(path) => setData({ ...data, post_image2: path })}
              label="Imagem da Publicação 2"
            />
            <div className="mt-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                URL do Post (Instagram)
              </label>
              <input
                type="url"
                value={data.post_url2 || ''}
                onChange={(e) => setData({ ...data, post_url2: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/DUF3bTgFHz6/"
              />
              <p className="text-xs text-gray-500 mt-1">
                💡 Cole o link direto do post do Instagram
              </p>
            </div>
          </div>

          {/* Post 3 */}
          <div>
            <h4 className="font-medium text-gray-700 mb-3">📸 Publicação 3</h4>
            <ImageUpload
              currentImage={data.post_image3}
              onImageChange={(path) => setData({ ...data, post_image3: path })}
              label="Imagem da Publicação 3"
            />
            <div className="mt-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                URL do Post (Instagram)
              </label>
              <input
                type="url"
                value={data.post_url3 || ''}
                onChange={(e) => setData({ ...data, post_url3: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/DUF3bTgFHz6/"
              />
              <p className="text-xs text-gray-500 mt-1">
                💡 Cole o link direto do post do Instagram
              </p>
            </div>
          </div>
        </div>

        {/* Default Instagram URL (fallback) */}
        <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL Padrão do Instagram (usado se o post não tiver URL específica)
          </label>
          <input
            type="url"
            value={data.instagram_url}
            onChange={(e) => setData({ ...data, instagram_url: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="https://www.instagram.com/bolacha.mulata/"
          />
        </div>
      </div>

      {message && (
        <div className={`p-4 rounded-lg ${message.includes('sucesso') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={isSaving}
        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50"
      >
        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </div>
  );
}
